export default "__VITE_PUBLIC_ASSET__84a41a8a__"